module.exports = __webpack_public_path__ + "img/city-silhouette-1.40bb2ce5.png";